import axios from "infra/http";
import { useQuery } from "react-query";
import { ArrecadacaoAutomaticaParametrosForm } from "./typings";

function useParametrosArrecadacaoAutomatica() {
  return useQuery(
    `/v1/arrecadacao/parametros-arrecadacao-automatica`,
    async () => {
      const { data } = await axios.get<ArrecadacaoAutomaticaParametrosForm>(
        `/v1/arrecadacao/parametros-arrecadacao-automatica`
      );

      return data;
    }
  );
}

export default useParametrosArrecadacaoAutomatica;
